module.exports = __webpack_public_path__ + "static/media/event-card-default-bg.781c1e96.png";